import axios from 'axios'

const generatePrevisionIndicator =  async function(obj, year, month){
    try{
        const   path = `/hr_indicator/${year}/${month}`
            ,   route = process.env.VUE_APP_API_ROUTE.concat( path )
            ,   response = await axios.post(route, obj)
        return response.data
    }
    catch( error ) {
        return error.response.data
    }
}

export default generatePrevisionIndicator
